import { render, staticRenderFns } from "./CsatResponses.vue?vue&type=template&id=10e47be6&scoped=true&"
import script from "./CsatResponses.vue?vue&type=script&lang=js&"
export * from "./CsatResponses.vue?vue&type=script&lang=js&"
import style0 from "./CsatResponses.vue?vue&type=style&index=0&id=10e47be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e47be6",
  null
  
)

export default component.exports